<template>
  <div>
    <a class="ag-nomal-action-menu" href="javascript:void(0);" @click="editCertification">
      <i class="material-icons-outlined align-middle">edit</i>
    </a>
    <a class="ag-nomal-action-menu" href="javascript:void(0);" @click="deleteCertification">
      <i class="material-icons-outlined align-middle">delete</i>
    </a>
  </div>
</template>

<script>
export default {
  methods: {
    editCertification: function() {
      this.params.context.componentParent.editCertification(this.params.data);
    },
    deleteCertification: function() {
      this.params.context.componentParent.deleteCertification(this.params.data);
    }
  }
};
</script>
